import CheckBoxToggle from "./CheckBoxToggle";
import TemplateRowSkeleton from "./TemplateRowSkeleton";

const TemplatesSelectionComp = ({ templateList, noteTemplateIdFun, loading }) => {
   return (
      <>
         <div className="vtwo-select-template-container">
            {loading ? (
               <div style={{ marginBottom: "-16px" }} className="pl-4 pr-4">
                  <TemplateRowSkeleton count={5} fullWidth="95%" sklettenMargen="4" sklettenPading="4.5" />
               </div>
            ) : (
               <div className="vtwo-temp-padding scrollbar-notes">
                  {templateList?.data?.map((item, index) => {
                     const tempId = item?.id;
                     return (
                        <>
                           <div className={`${index !== 0 && " border-bottom border"}`}></div>
                           <div key={item?.id} className={`template-flex-container`}>
                              <div className="vtwo-temp-title-text vtwo-custom-temp-truncate ">
                                 {item?.title || "Clinical note"}
                              </div>
                              <div className="toggle-flex-container">
                                 <CheckBoxToggle
                                    width="48px"
                                    height="31px"
                                    tempId={tempId}
                                    noteTemplateIdFun={noteTemplateIdFun}
                                 />
                              </div>
                           </div>
                        </>
                     );
                  })}
               </div>
            )}
         </div>
         <div className="vtwo-terms-of-service">
            By tapping “Let’s Go” you agree to our {""}
            {/* <div className="d-flex justify-content-center"> */}
            <a
               href="https://app-user-data-pbh-dev.s3.amazonaws.com/Terms+%26+Conditions+playback.pdf"
               target="_blank"
               rel="noopener noreferrer"
            >
               Terms of Service
            </a>
            ,{/* </div> */}
            <div className="d-flex justify-content-center">
               <a
                  href="https://app-user-data-pbh-dev.s3.amazonaws.com/privacy-policy+playback.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
               >
                  privacy policy
               </a>
               .
            </div>
         </div>
      </>
   );
};

export default TemplatesSelectionComp;
